/**
 * Safely opens an external URL in a new tab with security attributes
 * @param {string | null | undefined} url - The URL to open
 * @param {string | undefined} fallbackUrl - Optional fallback URL
 * @return {Window | null} The window object or null if opening failed
 */
export const openExternalLink = (url?: string | null, fallbackUrl?: string): Window | null => {
  const targetUrl = url || fallbackUrl;

  if (!targetUrl) {
    console.warn("openExternalLink: No URL provided");
    return null;
  }

  // Using noopener and noreferrer for security
  // - noopener: Prevents the new page from accessing window.opener
  // - noreferrer: Prevents passing referrer information
  return window.open(targetUrl, "_blank", "noopener,noreferrer");
};
